import { Box, HStack, Link, Text, VStack } from "@chakra-ui/react";
import { APP_STORE_LINKS } from "../../constants/AppStoreLinks";

interface PlayStoreButtonProps {
  onClick?: () => void;
}

const PlayStoreButton = ({ onClick }: PlayStoreButtonProps) => {
  const href = APP_STORE_LINKS.PLAY_STORE;

  const content = (
    <Box
      as={onClick ? "button" : "div"}
      display="flex"
      alignItems="center"
      px={4}
      py={2.5}
      borderRadius="lg"
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      boxShadow="0 2px 4px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.8)"
      _hover={{
        transform: "translateY(-1px)",
        boxShadow:
          "0 4px 8px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
        borderColor: "gray.300",
      }}
      _active={{
        transform: "translateY(0px)",
        boxShadow:
          "0 1px 2px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
      }}
      transition="all 0.2s ease"
      cursor="pointer"
      onClick={onClick}
    >
      <HStack spacing={3} align="center">
        {/* Google Play Logo */}
        <Box
          w="28px"
          h="28px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z"
              fill="#00D9FF"
            />
            <path
              d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z"
              fill="#00FF88"
            />
            <path
              d="M3.84 2.15L14.54 11.15L6.05 2.66L3.84 2.15Z"
              fill="#FFB800"
            />
            <path
              d="M18.27 12L14.54 15.73L6.05 21.34L16.81 15.12L18.27 12Z"
              fill="#FF3A44"
            />
            <path
              d="M14.54 8.27L6.05 2.66L16.81 8.88L18.27 12L14.54 8.27Z"
              fill="#FF3A44"
            />
          </svg>
        </Box>

        {/* Text Content */}
        <VStack align="flex-start" spacing={0}>
          <Text fontSize="10px" lineHeight="1" color="gray.600" fontWeight="400">
            GET IT ON
          </Text>
          <Text
            fontSize="18px"
            lineHeight="1.2"
            color="gray.800"
            fontWeight="600"
            letterSpacing="-0.5px"
          >
            Google Play
          </Text>
        </VStack>
      </HStack>
    </Box>
  );

  if (onClick) {
    return content;
  }

  return (
    <Link href={href} isExternal _hover={{ textDecoration: "none" }}>
      {content}
    </Link>
  );
};

export default PlayStoreButton;

